import { Youtube, Building2, Plug } from 'lucide-react';
import type { PlatformId } from '@utils/types/connections/connection.ts';

interface Props {
  platform: PlatformId;
  className?: string;
}

export default function PlatformIcon({ platform, className }: Props) {
  switch (platform) {
    case 'youtube':
      return <Youtube className={className} aria-hidden="true" />;
    case 'ibabs':
      return <Building2 className={className} aria-hidden="true" />;
    default:
      return <Plug className={className} aria-hidden="true" />;
  }
}
